import React from 'react'
import styled from 'styled-components'
import { AddCardModalText } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'

import { Questionmark } from 'src/assets'
import { Link, useLocation } from 'react-router-dom'

const AddCardWrapper = styled.div`
  padding-top: 43px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  width: auto;
  .choose {
    margin-top: 30px;
  }
  .expiry {
    display: flex;
    margin-top: 30px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .cvc {
    display: flex;
    position: relative;
    justify-content: space-between;
    /* width:100%; */
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 30px -47px;
  }
  .img {
    position: absolute;
    right: 10px;
    top: 29%;
    width: 27px;
  }
  .inputBox {
    width: 52%;
    margin-right: 15px;
  }
  .cvc {
    margin-left: 15px;
    width: 48%;
  }
  .top {
    margin-top: 170px;
  }
`
const AddBankCard = () => {
  let location = useLocation()
  return (
    <AddCardWrapper>
      <AddCardModalText className="wallet">Add your bank card</AddCardModalText>
      <p className="choose">
        Add your bank card now to easily save whenever you wish.{' '}
      </p>
      <QuicksaveInput type="number" name="Amount" placeholder="Card Number" />
      <div className="expiry">
        <QuicksaveInput
          className="inputBox"
          type="number"
          name="Amount"
          placeholder="Exp. Date"
        />
        <div className="cvc">
          <QuicksaveInput type="number" name="Amount" placeholder="CVC" />
          <img src={Questionmark} alt="" className="img" />
        </div>
      </div>
      <div className="top">
        <div className="line"></div>
        <Link to={`/big/permission`} state={{ backgroundLocation: location }}>
          <ModalButton>Add Bank Card</ModalButton>
        </Link>
      </div>
    </AddCardWrapper>
  )
}

export { AddBankCard }
